import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser'
// import reactStringReplace from "react-string-replace-recursively"
// import { renderToString } from 'react-dom/server'
// import Settings from '../settings'

// This component has:
// 1. Text area

import IconSquare from './icons/IconSquare'

class SectionText extends Component {

   componentDidMount() {

   }

   renderIconParagraph = (text, i) => {
      return (
         <span className="list-text" key={i}>
            <div className="text-inner">
              <div className="text-icon"><IconSquare size="12px"/></div>
              <div className="text-info text-description">
                 { ReactHtmlParser(text.text) }
              </div>
            </div>
         </span>
      )
   }

   renderIconParagraphs = (events) => {
      return (
         <div className="list-texts">
           <div className="list-texts-inner page-width">
           { events.map((event, i) => this.renderIconParagraph(event, i)) }
           </div>
         </div>
      )
   }

   renderBigParagraph = (text, gradientClass, layoutClass) => {
      const stripped_text = text.replace(/(<p>)/g,'').replace(/(<\/p>)/,'<br/><br/>')
      return (
         <div className="page-width">
            <div className={`text-block ${gradientClass} ${layoutClass}`}>
               &#8203;{ReactHtmlParser(stripped_text)}
               {/* dangerouslySetInnerHTML={{__html: text_with_icons}} */}
               {/* { ReactHtmlParser(text_with_icons) } */}
               {/* Across many Schools and Colleges, and in partnership with the extended Syracuse community, Syracuse University will examine the current relevance of the 1945 atomic attacks on Hiroshima and Nagasaki, Japan. <a href="">This is a text link</a> A series of public events and exhibitions will be organized around a special visit by Ms. Keiko Ogura, a public speaker and survivor of the Hiroshima attack. */}

            </div>
         </div>
      )
   }

   render() {
      const {
         text = 'Across many Schools and Colleges, and in partnership with the extended Syracuse community, Syracuse University will examine the current relevance of the 1945 atomic attacks on Hiroshima and Nagasaki, Japan. A series of public events and exhibitions will be organized around a special visit by Ms. Keiko Ogura, a public speaker and survivor of the Hiroshima attack.',
         text_sections = null,
         use_gradient = 'no',
         text_layout = 'block',
      } = this.props.data

      const gradientClasses = {
         'orange_white': 'text-gradient-orange-white',
         'white_orange': 'text-gradient-white-orange',
         'no': 0
      }
      const layoutClasses = {
         'block': 'text-block',
         'columns': 'text-columns',
         'columns_icons': 'text-columns'
      }
      const gradientClass = (gradientClasses[use_gradient]) ? `${gradientClasses[use_gradient]}` : ''
      const layoutClass = (layoutClasses[text_layout]) ? `${layoutClasses[text_layout]}` : ''

      // const icon_html = `<div className="text-icon">${renderToString(<IconSquare size="12px"/>)}</div>`
      // const text_with_icons = text.replace(/\[icon\]/g,icon_html)

      let render_text = null
      if (text_layout==='columns_icons') {
         // render_text = <p dangerouslySetInnerHTML={{__html: text_with_icons}}></p>
         // render_text = text_sections.map((section,i) => this.renderIconParagraph(section.text,i))
         render_text = this.renderIconParagraphs(text_sections)
      } else {
         render_text = this.renderBigParagraph(text, gradientClass, layoutClass)
      }

      // console.log(text);

      // const render_text = (text_layout==='columns') ? text_with_icons : text
      return (
         <div className="SectionText">

            {render_text}

         </div>
      )
   }
}

export default SectionText



// WEBPACK FOOTER //
// ./src/components/SectionText.js